import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import knowledgeService from "../../../services/knowledgeService";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const Knowledge = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [knowledge, setknowledge] = useState(null);

  useEffect(() => {
    const fetchknowledge = async () => {
      try {
        const res = await knowledgeService.getKnowledge(instanceToken.token, id);
        setknowledge(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchknowledge();
  }, [id]);

  const handleRemove = async () => {
    try {
      await knowledgeService.deleteKnowledge(instanceToken.token, id);
      homeAlert("Knowledge post have been removed.", false);
      navigate("/knowledges");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="Knowledge Details"
      subtitle="View and manage knowledge content"
      breadcrumbs={[
        { label: "Knowledges", path: "/knowledges" },
        { label: `Knowledge (ID - ${id})` },
      ]}
      listPath="/knowledges"
      imageUrl={knowledge?.image_url}
      loading={!knowledge}
      editPath={knowledge ? `/updateKnowledge/${knowledge.id}` : undefined}
      onRemove={handleRemove}
      contentSections={
        knowledge
          ? [
              {
                title: "Paragraph (English)",
                value: knowledge.paragraph_en,
                html: true,
                icon: "article",
              },
              {
                title: "Paragraph (Myanmar)",
                value: knowledge.paragraph_mm,
                html: true,
                myanmar: true,
                icon: "article",
              },
            ]
          : []
      }
      infoItems={
        knowledge
          ? [
              { label: "ID", value: String(knowledge.id), icon: "id" },
              {
                label: "Title (English)",
                value: knowledge.title_en,
                icon: "title",
              },
              {
                label: "Title (Myanmar)",
                value: knowledge.title_mm,
                icon: "title",
                myanmar: true,
              },
              ...dateInfoItems(knowledge),
            ]
          : []
      }
      quickActions={
        knowledge?.image_url
          ? [
              {
                label: "Preview Image",
                onClick: () =>
                  window.open(knowledge.image_url, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default Knowledge;
